import { isAllowedCompanyNameCharsOnly, isAllowedMultiLineCharsOnly } from "@finway-group/shared/lib/utils/validators"
import { isNotMultipleWhitespace, isNoWhiteSpacesAtStartOrEnd } from "@finway-group/shared/lib/utils/validators/input.validator"
import { Rule } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"

export const stringRules = {
    noExcessWhitespace: {
        validator: (_rule, value: string) => {
            if (value) {
                if (!isNoWhiteSpacesAtStartOrEnd(value)) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space_start_or_end")))
                }
                if (!isNotMultipleWhitespace(value)) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space_duplicate")))
                }
            }

            return Promise.resolve()
        },
    } as Rule,
    minLength: (minLength: number) =>
        ({
            validator: (_rule, value: string) => {
                if (!value?.length) {
                    // Allow empty strings - this rule is NOT intended for making a field mandatory, use the `mandatory` rule for that
                    return Promise.resolve()
                }
                if (value.length < minLength) {
                    return Promise.reject(new Error(i18n.t("validation:min.string", { min: minLength })))
                }

                return Promise.resolve()
            },
        }) as Rule,
    maxLength: (maxLength: number) =>
        ({
            validator: (_rule, value: string) => {
                if (value && value.length > maxLength) {
                    return Promise.reject(new Error(i18n.t("validation:max.string", { max: maxLength })))
                }

                return Promise.resolve()
            },
        }) as Rule,
    allowedCompanyNameCharsOnly: {
        validator: (_rule, value: string) => {
            if (!value) {
                return Promise.resolve()
            }
            if (!isAllowedCompanyNameCharsOnly(value)) {
                return Promise.reject(new Error(i18n.t("validation:invalid_characters")))
            }
            return Promise.resolve()
        },
    } as Rule,
    allowedMultiLineCharsOnly: {
        validator: (_rule, value: string) => {
            if (!value) {
                return Promise.resolve()
            }
            if (!isAllowedMultiLineCharsOnly(value)) {
                return Promise.reject(new Error(i18n.t("validation:invalid_characters")))
            }
            return Promise.resolve()
        },
    } as Rule,
}
